// FBO (fixed-base operator) name / address / phone, shown on the ShareJet and charter booking pages.
import { Space, Typography } from 'antd';

const { Text } = Typography;

// Structural, so both AdminBookingFbo (null when absent) and CharterFbo (undefined when absent) fit.
type Fbo = { name: string | null; address: string | null; phone: string | null };

export function FboView({ f }: { f?: Fbo | null }) {
  if (!f || (!f.name && !f.address && !f.phone)) return <Text type="secondary">—</Text>;
  return (
    <Space direction="vertical" size={0}>
      {f.name ? <Text strong>{f.name}</Text> : null}
      {f.address ? <Text>{f.address}</Text> : null}
      {f.phone ? <Text type="secondary">{f.phone}</Text> : null}
    </Space>
  );
}
